import { render, staticRenderFns } from "./revisiones.vue?vue&type=template&id=6e598189"
import script from "./revisiones.vue?vue&type=script&lang=js"
export * from "./revisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports